module.exports = __webpack_public_path__ + "static/img/laboratory8.29da80b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/laboratory8.jpg
// module id = wcca
// module chunks = 1